<script lang="ts">
	import Mill from '$lib/logos/mill.svelte';
	import Burger from '$lib/icons/burger.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import BurgerMenu from '$lib/storyblok/components/burgerMenu.svelte';
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';

	interface Props {
		content: ISbStoryData<{
			hide_center_menu: boolean;
			color: 'brown-1' | 'white';
			center_navigation: ISbStoryData['content'][];
			right_navigation: ISbStoryData['content'][];
			cta_title: string;
			cta_link: SbLink;
			burger_image: SbImage;
		}>['content'];
	}

	let { content }: Props = $props();

	let burgerMenu = $state<{ open: () => void }>();

	let btnClasses = $derived(content.color === 'brown-1' ? 'btn-white' : 'btn-brown');
</script>

<header
	use:editable={content}
	id="site-header"
	class="absolute inset-x-0 top-0 z-50 flex flex-col transition-transform"
	style="transform: translate3d(0, var(--banner-height), 0)"
>
	<div class="flex items-center justify-center px-5 py-3 lg:px-10 lg:py-5">
		<a href="/" class="flex flex-1" title="Home">
			<Mill class="h-8 text-{content.color || 'brown-1'} lg:h-10" />
		</a>

		{#if !content.hide_center_menu && content.center_navigation && content.center_navigation.length > 0}
			<nav class="flex-[2] max-lg:hidden">
				<ul class="flex items-center justify-center gap-x-2">
					{#each content.center_navigation as item}
						<Blok content={item} {btnClasses} />
					{/each}
				</ul>
			</nav>
		{/if}

		<div class="flex flex-1 items-center justify-end gap-x-2 lg:gap-x-5">
			{#if content.right_navigation && content.right_navigation.length > 0}
				<nav class="max-lg:hidden">
					<ul class="flex items-center gap-x-2 lg:gap-x-5">
						{#each content.right_navigation as item}
							<Blok content={item} {btnClasses} />
						{/each}
					</ul>
				</nav>
				<Button href="/food-recycler?cart=open">Shop</Button>
				<nav class="flex items-center text-{content.color || 'brown-1'} lg:hidden">
					<Button class="btn-tertiary" onclick={() => burgerMenu?.open()} title="Open burger menu">
						<Burger style="width: 40px; height: 40px" />
					</Button>
				</nav>
			{/if}
		</div>
	</div>
</header>

{#if content.right_navigation && content.right_navigation.length > 0}
	<BurgerMenu
		navList={content.center_navigation}
		signIn={content.right_navigation[0]}
		ctaLink={content.cta_link}
		ctaTitle={content.cta_title}
		ctaImage={content.burger_image}
		bind:this={burgerMenu}
	/>
{/if}
